import React, { useState, memo } from "react";
import { Link } from "react-router-dom";
import { FaShoppingCart, FaRegEdit, FaRegHeart, FaHeart } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { Spinner } from "react-bootstrap";
import { useCart } from "../../contexts/CartContext";
import "./ProductCard.css";

const readIsAdmin = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "null")?.isSuperuser === true;
  } catch {
    return false;
  }
};

const ProductCard = ({ product, openDeleteModal, href }) => {
  const [isFavorite, setIsFavorite] = useState(false);
  const [loading, setLoading] = useState(false);
  const isAdmin = readIsAdmin();
  const { addToCart } = useCart();

  const price = Number(product?.price) || 0;
  const discount = Number(product?.discount) || 0;
  const discountedPrice = discount ? price * (1 - discount / 100) : price;

  const imageSrc =
    product.cover ||
    product.productImages?.[0]?.url ||
    product.ProductImages?.[0]?.url ||
    "https://via.placeholder.com/400x400?text=No+Image";

  const handleFavoriteClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsFavorite(!isFavorite);
  };

  const handleAddToCart = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setLoading(true);
    await addToCart(product);
    setLoading(false);
  };

  return (
    <article className="product-card" dir="rtl">
      <div className="pcard">
        <Link to={href} className="pcard-media">
          <img
            src={imageSrc}
            alt={product.name}
            className="pcard-image"
            loading="lazy"
            decoding="async"
          />
          <span className="pcard-overlay">
            <span>عرض المنتج</span>
          </span>
          <div className="pcard-badges">
            {discount > 0 && (
              <span className="pcard-discount">خصم {discount}%</span>
            )}
            <button
              type="button"
              className={`pcard-fav ${isFavorite ? "active" : ""}`}
              onClick={handleFavoriteClick}
              aria-label="إضافة للمفضلة"
            >
              {isFavorite ? <FaHeart /> : <FaRegHeart />}
            </button>
          </div>
        </Link>

        <div className="pcard-body">
          <Link to={href} className="pcard-title-link">
            <h6 className="pcard-title">{product.name}</h6>
          </Link>

          <div className="pcard-footer">
            <div className="pcard-price">
              {discount > 0 ? (
                <>
                  <span className="pcard-price-now">
                    {discountedPrice.toFixed(2)} ر.س
                  </span>
                  <span className="pcard-price-old">{price.toFixed(2)} ر.س</span>
                </>
              ) : (
                <span className="pcard-price-now">{price.toFixed(2)} ر.س</span>
              )}
            </div>

            {isAdmin ? (
              <div className="pcard-admin">
                <button
                  type="button"
                  className="pcard-ctrl delete"
                  onClick={() => openDeleteModal(product)}
                  aria-label="حذف المنتج"
                >
                  <MdDelete />
                </button>
                <Link
                  className="pcard-ctrl edit"
                  to={`/admin/update_product/${product.id}`}
                  title="تحديث المنتج"
                >
                  <FaRegEdit />
                </Link>
              </div>
            ) : (
              <button
                type="button"
                className="pcard-cart"
                onClick={handleAddToCart}
                disabled={loading}
                aria-label="إضافة للسلة"
                title="إضافة للسلة"
              >
                {loading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  <FaShoppingCart />
                )}
              </button>
            )}
          </div>
        </div>
      </div>
    </article>
  );
};

export default memo(ProductCard);
